import { select } from 'redux-saga/effects'
import { selectUid } from '../../selectors'

/* eslint-disable import/prefer-default-export */

// call this passing in your document before any save to the firestore
export function* prepareForSave(document) {
	if (document.uid) {
		return document
	}
	const uid = yield select(selectUid)
	return { ...document, uid }
}



// WEBPACK FOOTER //
// ./src/redux/saga/firebase/document.js